import { authServiceApi } from "../../../../app/authServiceApi";
import { API_URL } from "../../../../constants/apiUrl";
import { CommonResponse, GetQueryArgsType } from "../../../../types";
import {
  AllKPIBatchParams,
  AllKPIBatchResponse,
  AllPayrollBatchSummaryParams,
  AllPayrollBatchSummaryResponse,
  CompanyWallets,
  SingleKPIBatchResponse,
  SinglePayrollBatchResponse,
} from "./payroll.type";

export const payrollApi = authServiceApi.injectEndpoints({
  endpoints: (builder) => ({
    // ------ Mutations ------
    generatePayroll: builder.mutation({
      query: (data) => ({
        url: API_URL.generatePayroll,
        method: "POST",
        body: data,
      }),
      invalidatesTags: (result) => {
        if (result) return ["GetKPIBatch"];
        return [];
      },
    }),

    sentToDisbursement: builder.mutation({
      query: (data) => ({
        url: API_URL.sentToDisbursement,
        method: "POST",
        body: data,
      }),
      invalidatesTags: (result) => {
        if (result) return ["GetPayrollBatch"];
        return [];
      },
    }),

    // ------ Queries ------
    getAllKPIBatch: builder.query<
      CommonResponse<AllKPIBatchResponse>,
      GetQueryArgsType<AllKPIBatchParams>
    >({
      query: (queryArgs) => ({
        url: API_URL.getAllKPIBatch,
        ...queryArgs,
      }),
      providesTags: ["GetKPIBatch"],
    }),

    getKPIBatchDetails: builder.query<
      CommonResponse<SingleKPIBatchResponse>,
      { args: GetQueryArgsType<AllKPIBatchParams>; id: number }
    >({
      query: ({ id, args }) => ({
        url: `${API_URL.getKPIBatchDetails}/${id}/details`,
        ...args,
      }),
      providesTags: (_result, _error, { id }) => [{ type: "GetKPIBatch", id }],
    }),

    getAllPayrollBatch: builder.query<
      CommonResponse<AllKPIBatchResponse>,
      GetQueryArgsType<AllKPIBatchParams>
    >({
      query: (queryArgs) => ({
        url: API_URL.getAllPayrollBatch,
        ...queryArgs,
      }),
      providesTags: ["GetPayrollBatch"],
    }),

    getPayrollBatchDetails: builder.query<
      CommonResponse<SinglePayrollBatchResponse>,
      { args: GetQueryArgsType<AllKPIBatchParams>; id: number }
    >({
      query: ({ id, args }) => ({
        url: `${API_URL.getPayrollBatchDetails}/${id}/details`,
        ...args,
      }),
      providesTags: (_result, _error, { id }) => [
        { type: "GetPayrollBatch", id },
      ],
    }),

    getCompanyWallet: builder.query<CommonResponse<CompanyWallets>, any>({
      query: ({ id, args }) => ({
        url: `${API_URL.getCompanyWallet}`,
        ...args,
      }),
      providesTags: () => ["GetCompanyWallet"],
    }),

    getPayrollBatchSummary: builder.query<
      CommonResponse<AllPayrollBatchSummaryResponse>,
      GetQueryArgsType<AllPayrollBatchSummaryParams>
    >({
      query: (queryArgs) => ({
        url: API_URL.getPayrollBatchSummary,
        ...queryArgs,
      }),
      providesTags: ["GetPayrollBatchSummary"],
    }),
  }),
});

export const {
  // ------ Mutation Hooks ------
  useGeneratePayrollMutation,
  useSentToDisbursementMutation,

  // ------ Query Hooks ------
  useGetAllKPIBatchQuery,
  useGetKPIBatchDetailsQuery,
  useGetAllPayrollBatchQuery,
  useGetPayrollBatchDetailsQuery,
  useGetCompanyWalletQuery,
  useGetPayrollBatchSummaryQuery,
} = payrollApi;
